import { flow, types } from 'mobx-state-tree'
import { crDrProcessApprovals } from '../../network/crDrProcessApprovals'
import { creditAdjustReq } from '../../network/creditAdjustReq'
import { MessageTypes, getErrorMessage } from '../../utils'
import { RootStore } from '../store'

const Adjustment = types.model('Adjustment', {
  id: types.optional(types.string, ''),
  entityId: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  invoice: types.optional(types.string, ''),
  methodType: types.optional(types.string, ''),
  methodSubType: types.optional(types.string, ''),
  originalId: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
})

const CreditAdjustment = types
  .model('CreditAdjustment', {
    adjustment: types.optional(Adjustment, {}),
  })
  .actions((self) => ({
    bulkUpdate: flow(function* (txns: any) {
      const errorData: any = []
      for (let i = 0; i < txns.length; i++) {
        const data = txns[i]
        try {
          let response
          response = yield creditAdjustReq(data, RootStore.session.getTokens)

          errorData.push({ status: 'SUCCESS', message: response?.message, code: '' })
        } catch (e) {
          errorData.push({ status: 'Failure', message: getErrorMessage(e), code: (e as any)?.data?.error?.code ?? '' })
        }
        yield new Promise((r) => setTimeout(r, 200))
      }
      return errorData
    }),
    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield crDrProcessApprovals(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message ?? 'Approved', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    bulkApproval: flow(function* (approveList: any) {
      const errorData: any = []
      for (let i = 0; i < approveList.length; i++) {
        const data = approveList[i]
        const userName = data?.username
        if (userName === RootStore.user.name) {
          errorData.push({
            status: 'Failure',
            message: 'Logged in user and Checker can not be same',
            code: '',
          })
        } else {
          const modifiedData = {
            id: Number(data.id), // 0
            type: data.approvalType, // 'DELETE_APPROVAL',
            status: data?.approvalStatus?.toLowerCase() === 'true' ? true : false, // true/false
          }
          try {
            const response = yield crDrProcessApprovals(modifiedData, RootStore.session.getTokens)
            errorData.push({ status: 'SUCCESS', message: response?.message, code: '' })
          } catch (e) {
            errorData.push({
              status: 'Failure',
              message: getErrorMessage(e),
              code: (e as any)?.data?.error?.code ?? '',
            })
          }
        }
        yield new Promise((r) => setTimeout(r, 200))
      }
      return errorData
    }),
  }))

const creditadjustmentData = CreditAdjustment.create({
  adjustment: {
    id: '1',
    merchantId: '1000100012012',
    status: 'Onhold',
  },
})

export { CreditAdjustment, creditadjustmentData }
